import { Link } from 'react-router-dom';
import { getLatestComics } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

export default function LatestUpdates() {
  const latestComics = getLatestComics(6);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-2">追更不迷路，热门韩漫每日更新</p>
          </div>
          <Link
            to="/category/romance"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {latestComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>

        <Link
          to="/category/romance"
          className="sm:hidden flex items-center justify-center gap-1 mt-6 text-sm text-primary-500 font-medium"
        >
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}